import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const BackgroundQuestions = ({ 
  questionNumber, 
  categories, 
  totalQuestions 
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="你认为自己最擅长的2-3门课程是什么?" 
          subtitle="(提示：可以想想哪些课程/领域你学得快、掌握得透、成绩常排前面、朋友/老师觉得你这方面特别有天赋)"
          value={formData.bestCourses}
          onChange={(value) => handleInputChange('bestCourses', value)}
          inputType="textarea"
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="你认为自己最擅长的2-3个能力或个人特质是什么?" 
          subtitle="(提示：可以想想平时别人羡慕你的地方，或做事时自己觉得特别擅长的能力/特质)"
          examples="(例子：说服别人、耐心、快速学习能力、注意细节等)"
          value={formData.topSkills}
          onChange={(value) => handleInputChange('topSkills', value)}
          inputType="textarea"
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="有没有哪一点或几点，是别人（老师/家人/朋友/coworker）比较常提醒/吐槽你的?" 
          subtitle="(如果没有也可以写&quot;暂无&quot;)"
          examples="(例如：容易粗心、没耐心、严重拖延、没恒心、容易焦虑、表达能力、时间管理能力、被动、组织能力弱、容易紧张等)"
          value={formData.weakness}
          onChange={(value) => handleInputChange('weakness', value)}
          inputType="textarea"
        />
      );
    case 4:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="如果有的话，可以给每个点举个例子吗?" 
          subtitle="(如果没有请填&quot;暂无&quot;)"
          value={formData.weaknessExamples}
          onChange={(value) => handleInputChange('weaknessExamples', value)}
          inputType="textarea"
        />
      );
    case 5:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={5}
          totalQuestions={totalQuestions}
          title="请描述你的英文程度。如果用英语表达一件复杂的事，比如讲一个小故事、解释一个道理，你觉得自己表达出来的效果大概是怎样的?" 
          inputType="radio"
          options={[
            "A. 英文和中文表达效果差不多",
            "B. 英文表达略有差距（有时候词找不到、表达没那么细、偶尔小错误）",
            "C. 英文表达差距比较大（很多细节表达不了、讲不流畅、会跳过一些内容）",
            "D. 我会觉得用英文讲很难、可能讲不完整"
          ]}
          customOption={true}
          customValue={formData.englishLevelOther}
          onCustomChange={(value) => handleInputChange('englishLevelOther', value)}
          value={formData.englishLevel}
          onChange={(value) => handleInputChange('englishLevel', value)}
        />
      );
    case 6:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={6}
          totalQuestions={totalQuestions}
          title="如果中文表达的一个&quot;我带领团队完成任务&quot;领导力故事和英文表达的版本有差距，你认为是差在哪?" 
          subtitle="(例如：词汇、逻辑、结构、紧张、地道表达、语法错误、口音、我也不知道等)"
          value={formData.englishStoryDifference}
          onChange={(value) => handleInputChange('englishStoryDifference', value)}
          inputType="textarea"
        />
      );
    case 7:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={7}
          totalQuestions={totalQuestions}
          title="你未来在美国找工作时是否需要雇主提供工作签证 (work visa) sponsorship?" 
          subtitle="(备注：如果你是美国公民或绿卡持有者 → 不需要；其他国家公民 → 需要)"
          inputType="radio"
          options={["是", "否"]}
          value={formData.needVisa}
          onChange={(value) => handleInputChange('needVisa', value)}
        />
      );
    case 8:
      return (
        <QuestionCard 
          categoryIcon={categories[1].icon}
          categoryName={categories[1].name}
          questionNumber={8}
          totalQuestions={totalQuestions}
          title="你的签证类别是哪种?" 
          subtitle="(如果不确定可以写备注)"
          inputType="radio"
          options={[
            "TN签证（加拿大/墨西哥公民）", 
            "H1B1签证（新加坡/智利公民）", 
            "H1B签证（其他国家）"
          ]}
          customOption={true}
          customValue={formData.visaTypeOther}
          onCustomChange={(value) => handleInputChange('visaTypeOther', value)}
          value={formData.visaType}
          onChange={(value) => handleInputChange('visaType', value)}
        />
      );
    default:
      return null;
  }
};

export default BackgroundQuestions;